export default __webpack_public_path__ + "static/media/logo192.43ebc2c8.svg";